<template>
  <v-dialog v-model="show" persistent max-width="650px">
    <v-card  min-height="80vh">
      <v-toolbar  color="green lighten-3" dark>
        <v-toolbar-title class="headline"
          >Kartläggning {{ student.name }}</v-toolbar-title
        >
      </v-toolbar>
      <!-- <v-card-text> -->


 <v-window v-model="step" min-height='60vh' >
     <v-window-item :value="1">
              <div class="pa-3 text-xs-center big" >
       <h3 class="title font-weight-light mb-2">Vad är en kartläggning?</h3>
          <span class="caption grey--text">En kartläggning utförs för att man ska få in mer information om en individs betende....</span>
          <span class="caption grey--text">Du ska svara på frågorna i lugn och ro och får gärna gå tillbaka och ändra svaren i efterhand om din uppfattning har ändrats. Det är helt okej att inte svara på frågor om man inte har någon uppfattning..</span>
          <span class="caption red--text">Hinner du bara fylla i några frågor? Det gör inget, tryck på skicka in så kan du fortsätta nästa gång du får tid.</span>
              </div>
      </v-window-item>
      <v-window-item :value="2">
        <v-card-text>
           <span class="headline" id="head">Beskriv </span>
          <div v-for="(item, index) in Questions.slice(0, 2)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
          </div>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
                <v-card-text class="big">
           <span class="headline mb-5" id="head" color="orange">Skatta elevens </span>
                <div v-for="(item, index) in Questions.slice(2, 6)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>

            <v-radio-group v-if="item.T == 'Mål'" v-model="Answers[index+2]" row>
              <v-radio label="Når målen" value="1"></v-radio>
              <v-radio label="Når ej målen" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else-if="item.T == 'Huvud'" v-model="Answers[index+2]" row>
              <v-radio label="Huvudsakligen fungerande" value="1"></v-radio>
              <v-radio label="Ej fungerande" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
                        <v-radio-group v-else-if="item.T == 'Icke'" v-model="Answers[index+2]" row>
              <v-radio :label="Cap(item.E)" value="1"></v-radio>
              <v-radio :label="'Icke '+ item.E" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else v-model="Answers[index+2]" row>
              <v-radio
                v-for="i in parseInt(item.T)"
                :key="i"
                :label="i.toString()"
                :value="i.toString()"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="4">    
           <v-card-text class="big">
           <span class="headline" id="head">Skatta elevens förmåga</span>
                <div v-for="(item, index) in Questions.slice(6, 10)" :key="index">
                      <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
            <v-radio-group v-if="item.T == 'Mål'" v-model="Answers[index+6]" row>
              <v-radio label="Når målen" value="1"></v-radio>
              <v-radio label="Når ej målen" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else-if="item.T == 'Huvud'" v-model="Answers[index+6]" row>
              <v-radio label="Huvudsakligen fungerande" value="1"></v-radio>
              <v-radio label="Ej fungerande" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
                        <v-radio-group v-else-if="item.T == 'Icke'" v-model="Answers[index+6]" row>
              <v-radio :label=" Cap(item.E)" value="1"></v-radio>
              <v-radio :label="'Icke '+ item.E" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else v-model="Answers[index+6]" row>
              <v-radio
                v-for="i in parseInt(item.T)"
                :key="i"
                :label="i.toString()"
                :value="i.toString()"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>
           <v-window-item :value="5">     
                <v-card-text class="big">
           <span class="headline" id="head">Skatta elevens förmåga</span>

                <div v-for="(item, index) in Questions.slice(10, 14)" :key="index">
                      <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
            <v-radio-group v-if="item.T == 'Mål'" v-model="Answers[index+10]" row>
              <v-radio label="Når målen" value="1"></v-radio>
              <v-radio label="Når ej målen" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else-if="item.T == 'Huvud'||'Huvud2'==item.T" v-model="Answers[index+10]" row>
              <v-radio v-if="'Huvud2'==item.T" label="Huvudsakligen fungerande och uppfyller målen" value="3"></v-radio>
              <v-radio label="Huvudsakligen fungerande" value="1"></v-radio>
              <v-radio label="Ej fungerande" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
                        <v-radio-group v-else-if="item.T == 'Icke'" v-model="Answers[index+10]" row>
              <v-radio :label="Cap(item.E)" value="1"></v-radio>
              <v-radio :label="'Icke '+ item.E" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else v-model="Answers[index+10]" row>
              <v-radio
                v-for="i in parseInt(item.T)"
                :key="i"
                :label="i.toString()"
                :value="i.toString()"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>
            <v-window-item :value="6">
        <v-card-text class="big">
           <span class="headline" id="head">Skatta elevens</span>
                <div v-for="(item, index) in Questions.slice(14, 18)" :key="index">
                      <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
            <v-radio-group v-if="item.T == 'Mål'" v-model="Answers[index+14]" row>
              <v-radio label="Når målen" value="1"></v-radio>
              <v-radio label="Når ej målen" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
            <v-radio-group v-else-if="item.T == 'Huvud' || 'Huvud2'==item.T" v-model="Answers[index+14]" row>
              <v-radio v-if="'Huvud2'==item.T" label="Huvudsakligen fungerande och uppfyller målen" value="3"></v-radio>
              <v-radio label="Huvudsakligen fungerande" value="1"></v-radio>
              <v-radio label="Ej fungerande" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
                        <v-radio-group v-else-if="item.T == 'Icke'" v-model="Answers[index+14]" row>
              <v-radio :label=" Cap(item.E)" value="1"></v-radio>
              <v-radio :label="'Icke '+ item.E" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
               <v-radio-group v-else v-model="Answers[index+14]" row>
              <v-radio
                v-for="i in parseInt(item.T)"
                :key="i"
                :label="i.toString()"
                :value="i.toString()"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>
            <v-window-item :value="7">
        <v-card-text class="big">
           <span class="headline" id="head">Skatta elevens</span>
          <div v-for="(item, index) in Questions.slice(18, 22)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index+18]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
              <v-radio-group v-else-if="item.T == 'Huvud' || 'Huvud2'==item.T" v-model="Answers[index+18]" row>
              <v-radio v-if="'Huvud2'==item.T" label="Huvudsakligen fungerande och uppfyller målen" value="3"></v-radio>
              <v-radio label="Huvudsakligen fungerande" value="1"></v-radio>
              <v-radio label="Ej fungerande" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
              <v-radio-group v-else-if="item.T == 'Bra'" v-model="Answers[index+18]" row>
              <v-radio label="Bra" value="1"></v-radio>
              <v-radio label="Mindre bra" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>
           <v-window-item :value="8">
        <v-card-text class="big">
           <span class="headline" id="head">Skatta </span>
          <div v-for="(item, index) in Questions.slice(22, 24)" :key="index">
            <span id="bellow" class="title font-weight-regular justify-space-between">  {{ item.Q }} </span>
              <div v-if="item.T == 'T'" >
                    <v-textarea
          solo
          v-model="Answers[index+22]"
          name="input-7-4"
          label="Efter bästa förmåga"
        ></v-textarea>
            </div>
            <v-radio-group v-else-if="item.T == 'Bra'" v-model="Answers[index+22]" row>
              <v-radio label="Bra" value="1"></v-radio>
              <v-radio label="Mindre bra" value="0"></v-radio>
              <v-radio label="Vet inte" value="2"></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
      </v-window-item>
           <v-window-item :value="9">
                <div class="pa-3 text-xs-center big">
          <v-img
            class="mb-3"
            contain
            height="128"
            src="https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/google/298/partying-face_1f973.png"
          ></v-img>
          <h3 class="title font-weight-light mb-2">Du är nu klar!</h3>
          <span class="caption grey--text">Bra jobbat!</span>
          <br>
            <v-btn color="green lighten-1" text dark @click="change()">
          Skicka in!
        </v-btn>   
        </div>



                  
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>   

      <v-btn
        :disabled="step === 1"
        flat
        @click="step--"
      >
        Tillbaka
      </v-btn>
      <v-spacer></v-spacer>

   <v-item-group
        class="text-xs-center"
        mandatory
      >
        <v-item
          v-for="n in 9"
          :key="`btn-${n}`"
        >
          <v-btn           
                      icon   
                      :color="step==n?'green lighten-1':step>n?'green lighten-3':'yellow lighten-3'"     
        @click="step= n"
          >
            <v-icon>{{n==9?'star':n==1?'info':'rule'}}</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-spacer></v-spacer>

      <v-btn
        :disabled="step === 9"
        color="primary"
        depressed
        @click="step++"
      >
        Nästa
      </v-btn>
    </v-card-actions>
               <v-btn color="green lighten-1" text dark @click="change()">
          Spara
        </v-btn>
  </v-card>

  </v-dialog>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Questions",

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(visible) {
      if (visible) {
        let AID = this.student.answerId.findIndex((M) => M == this.id);
        if (AID != -1) {
          this.Answers = this.student.answer[AID].answers;
          this.Answers = this.Answers.map((x) => (x == "" ? null : x));
          this.OldAnswers = [...this.Answers];
        } else {
          this.Answers = [];
          this.OldAnswers = [];
        }
      }
    },
  },
  created() {},
  props: {
    student: Object,
    value: Boolean,
    id: String,
    // Answers: Array
  },
  data() {
    return {
      step:1,
Questions: [
        { Q: "elevens styrkor:", T: "T" }, //0 hälsa 
        { Q: "huvudsaklig problematik:", T: "T" },   //1     hälsa 
        { Q: " förutsättningar och förmåga att nå kunskapskraven:", T: "Mål" }, //2 MÅL kunskapsinhämtning
        { Q: "läsförmåga:", T: "Mål" }, //3 Kunskapsinhämtning 
        { Q: "skrivförmåga:", T: "Mål" },//4 Kunskapsinhämtning
        { Q: "förmåga att ta till sig undervisning:", T: "Huvud" },//5 Kunskapsinhämtning 
        { Q: "att påbörja skolarbete:", T: "Huvud" },//6 impuls  
        { Q: "att avsluta skolarbete:", T: "Huvud" },//7 impuls 
        { Q: "att ta till sig och förstå instruktioner:", T: "Huvud" }, //8 kunskapsinhämtning
        { Q: "inom impulskontroll:", T: "Icke" , E: "åldersadvekat"}, //9 impuls
        { Q: "att hålla uppmärksamhet:", T: "Icke" , E: "åldersadvekat"}, //10 impuls
        { Q: "att fokusera:", T: "Icke" , E: "åldersadvekat"},         //11 impuls
        { Q: "att planera och genomföra skolarbete:", T: "Huvud2" }, //12 mål 
        { Q: "till sociala samspel med skolpersonal:", T: "Huvud" }, //13 social
        { Q: "förmåga till sociala samspel med andra elever:", T: "Huvud" },           //14 social
        { Q: "talförmåga:", T: "Huvud" }, //15 kunskap 
        { Q: "språkliga nivå:", T: "Icke" , E: "åldersadvekat"}, //16 kunskap
        { Q: "förmåga att redovisa kunskaper:", T: "Huvud2" }, //16  mål
        { Q: "finmotorik:", T: "Huvud" },                     //!8 hälsa
        { Q: "grovmotorik:", T: "Huvud" },                     //!9 hälsa
        { Q: "närvaro:", T: "Huvud" },                     //20 närvaro
        { Q: "psykiska hälsa:", T: "Bra" },                     //21 hälsa
        { Q: "elevens fysiska hälsa:", T: "Bra" },                     //22 hälsa
         { Q: "Beskriv övrig information som är relevant för kartläggningen:", T: "T" },      //23
      ],

      // Questions: [
      //   { Q: "Är eleven stökig?", T: "YN" },
      //   { Q: "Är eleven trökig?", T: "YN" },
      //   { Q: "Hur energirik upplever du eleven?", T: "5" },
      //   { Q: "Hur intresserad upplever du eleven?", T: "10" },
      // ],
      Answers: [],
      OldAnswers: [],
    };
  },

  methods: {

Cap(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
},


    ...mapActions("mappings", ["updateAnswer"]),
    ...mapActions(["showSuccessSnackbar"]),
    change() {

      //  (this.Answers)
      let difference = this.Answers.filter((x) => !this.OldAnswers.includes(x));
      if (difference.length != 0) {
        let answers = [...this.Answers];
        for (let index = 0; index < answers.length; index++) {
          if (typeof answers[index] === "undefined") {
            answers[index] = "";
          }
        }

        let legitA = answers.filter((item) => item != "");
        let rest = legitA.length / this.Questions.length;
        let output = {
          teacherId: this.id,
          id: this.student.id,
          answers: answers,
          step: rest,
        };
      //  (output)

        this.updateAnswer(output);
        this.showSuccessSnackbar("Kartläggningen är uppdaterad. Bra jobbat!");
      }
      this.show = false;
    },
  },
};
</script>
<style >
#head{
  background-color: #F06292;
  color:white;
  padding: 5px;
  border-radius: 10px;
  margin-bottom: 20px !important;
}
#bellow{ margin-left: 5px;}

.big{
  min-height: 55.5vh;
}
</style>